import React, { Fragment, useState } from 'react';
import {
    Card,
    CardContent,
    CardHeader,
    Divider,
    makeStyles,
    CardProps,
} from '@material-ui/core';
import {
    IServiceClient,
    TServiceClientVehicle,
} from 'src/interfaces/serviceClient';
import { WhatsAppButton } from 'src/components/Lead/WhatsApp/components/WhatsAppButton';
import { ConversationLink } from 'src/components/Lead/WhatsApp/components/ConversationLink';
import { TAreas } from 'src/constants/lead/leadTypes';
import { getTemplateArea } from 'src/components/Lead/WhatsApp/utils/getTemplateArea';
import { getConversationApi } from 'src/components/Lead/WhatsApp/utils/getConversationApi';
import { ModalTemplates } from 'src/modules/conversations/components/modalTemplates';
import { TCurrentTemplate } from 'src/modules/conversations/components/modalTemplates/types';
import { CURRENT_TEMPLATE_DEFAULT } from 'src/modules/conversations/constants/threads';
import { IVehicle } from 'src/interfaces/vehicle';
import { useServiceClient } from 'src/hooks';

const useStyles = makeStyles(() => ({
    root: {},
}));

export interface ISendWhatsAppServiceClientProps
    extends Omit<CardProps, 'serviceClient'> {
    serviceClient: IServiceClient;
    vehicle: TServiceClientVehicle;
}

export const SendWhatsAppServiceClient = ({
    serviceClient,
    vehicle,
    ...props
}: ISendWhatsAppServiceClientProps) => {
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [currentTemplate, setCurrentTemplate] = useState<TCurrentTemplate>(
        CURRENT_TEMPLATE_DEFAULT
    );
    const area: TAreas = getTemplateArea(serviceClient);
    const handleOpen = () => setOpen(true);
    const { sendTemplateServiceClient, loading } = useServiceClient();

    const leadVehicle: string | Partial<IVehicle> = vehicle
        ? {
            _id: vehicle._id,
            model: vehicle.model,
            make: {
                _id: vehicle.make._id,
                name: vehicle.make.name,
                group: [],
            },
        }
        : serviceClient.vehicle;

    const serviceClientWithVehicle: IServiceClient = {
        ...serviceClient,
        vehicle: leadVehicle,
    };

    return (
        <Fragment>
            <ModalTemplates
                open={open}
                setOpen={setOpen}
                serviceClient={serviceClientWithVehicle}
                currentTemplate={currentTemplate}
                setCurrentTemplate={setCurrentTemplate}
                contextType="serviceClient"
                maxWidth="lg"
                contextKey={`${serviceClientWithVehicle?._id}-${vehicle?._id}`}
                handleSendTemplate={(template: TCurrentTemplate) =>
                    sendTemplateServiceClient(
                        template,
                        serviceClientWithVehicle._id,
                        { playSound: false }
                    )
                }
                loading={loading}
            />
            <Card className={classes.root} {...props}>
                <CardHeader title="WhatsApp" />
                <Divider />
                <CardContent>
                    <WhatsAppButton onClick={handleOpen} />
                    {serviceClient.conversation && (
                        <ConversationLink
                            conversation={serviceClient.conversation._id}
                            area={area}
                            api={getConversationApi(serviceClient)}
                        />
                    )}
                </CardContent>
            </Card>
        </Fragment>
    );
};

